import React, { useState, useEffect } from 'react';
import InputFilter from './InputFilter';
import FilteredResults from './FilteredResults';

const { auto_dealers: autoDealers } = window.autoDealersData;

const AutoDealers = () => {
  // Setting initial state for input values and dealers
  const [values, setValues] = useState({ dealers: '' });
  const [dealers, setDealers] = useState([]);

  // Waiting until component ahs mounted before setting state on dealers
  useEffect(() => {
    setDealers(autoDealers);
  }, []);

  const handleInputChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });

    let filteredDealers = dealers;

    // filtering dealers by title
    filteredDealers = autoDealers.filter(dealer => {
      let title = dealer.title.toLowerCase();
      return title.indexOf(event.target.value.toLowerCase()) !== -1;
    });

    setDealers(filteredDealers);
  };

  return (
    <>
      <InputFilter handleInputChange={handleInputChange} values={values} />
      <FilteredResults dealers={dealers} />
    </>
  );
};

export default AutoDealers;
